import moment from "moment";
import Vue from 'vue';

Vue.filter('datahora', function (value, empty = '-') {
  return !value ? empty : moment(value).format("DD/MM/YYYY HH:mm:ss");
});
